import type { Handleiding } from './soort';

export const ru: Handleiding = {
  code: 'ru',
  titel: 'Руководство',
  inleiding:
    'Ask Gio Tolk переводит разговор между двумя людьми, которые не говорят на одном языке. Ниже описано, что делает каждая кнопка.',
  knop: 'Открыть руководство',
  sluiten: 'Закрыть',
  groepGebruik: 'Участвовать в разговоре',
  groepBeheer: 'Настройка и управление',
  delen: [
    {
      titel: 'Говорить',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Говори',
          uitleg:
            'Нажми один раз, чтобы начать. Запись останавливается сама, как только ты помолчишь чуть больше секунды, или если нажмёшь ещё раз. Через минуту она останавливается в любом случае.',
        },
        {
          kop: 'Один звук за раз',
          uitleg:
            'Пока приложение говорит, записывать нельзя. А пока записываешь ты, пришедший перевод ждёт, когда ты закончишь. Иначе микрофон запишет приложение и решит, что это сказал ты.',
        },
        {
          kop: 'Напиши сообщение здесь',
          uitleg:
            'Работает наряду с речью и проходит через тот же перевод. Enter отправляет, shift с enter делает новую строку.',
        },
        {
          kop: 'Время на исправление',
          uitleg:
            'Здесь ты задаёшь, сколько секунд у тебя есть, чтобы перечитать записанную фразу до отправки. На нуле она уходит сразу.',
        },
        {
          kop: 'Всегда проверять и отправлять самому',
          uitleg:
            'Больше никаких часов. Каждая фраза ждёт, пока ты нажмёшь отправить. Для тех, кто хочет проверять каждую фразу.',
        },
        {
          kop: 'Сразу проигрывать перевод',
          uitleg:
            'Включено. Выключи, если предпочитаешь сначала прочитать и сам решать, когда слушать.',
        },
      ],
    },
    {
      titel: 'Читать сообщения',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'То, что крупно',
          uitleg:
            'То, что на ТВОЁМ языке, показано крупно. В твоей собственной фразе это твой исходный текст, чтобы ты мог проверить, правильно ли приложение тебя расслышало. В фразе собеседника это перевод.',
        },
        {
          kop: 'Развернуть оригинал или перевод',
          uitleg: 'Другой язык находится ниже, свёрнутый. Нажми на строку, чтобы открыть её.',
        },
        {
          kop: 'Треугольник',
          uitleg: 'Проигрывает перевод ещё раз.',
        },
        {
          kop: 'Говорящая голова',
          uitleg:
            'Проигрывает собственную запись собеседника. Появляется только у ПРОИЗНЕСЁННОГО сообщения и только если включено «отправлять и свой голос». У набранного сообщения записи нет.',
        },
      ],
    },
    {
      titel: 'Кнопки вверху экрана',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Минус и плюс',
          uitleg: 'Делает текст меньше или больше. В пять шагов, и настройка сохраняется.',
        },
        {
          kop: 'Микрофон',
          uitleg: 'Прячет кнопку речи, если ты всё равно только печатаешь. Так экономится место.',
        },
        {
          kop: 'Клавиатура',
          uitleg:
            'Прячет поле ввода. Одно из двух всегда остаётся включённым, иначе ты уже ничего не сможешь сказать.',
        },
      ],
    },
    {
      titel: 'Вход',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'На каком языке ты говоришь',
          uitleg:
            'Этот выбор задаёт и язык кнопок и сообщений. Так что вы оба видите разные экраны, и так и задумано.',
        },
        {
          kop: 'Твой голос в переводе',
          uitleg:
            'Выбери, звучишь ты как мужчина или как женщина. Это относится к ТЕБЕ, а не к комнате: каждый участник выбирает отдельно.',
        },
        {
          kop: 'Разрешение на микрофон',
          uitleg:
            'Браузер спрашивает об этом при входе. Если откажешь, печатать всё равно можно. Разрешение можно дать позже через замочек в адресной строке.',
        },
      ],
    },
    {
      titel: 'Внизу, свёрнуто',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Запасной словарь',
          uitleg:
            'Слова, которые всегда должны переводиться одинаково: имена, профессиональные термины, марки. Действует для всей комнаты.',
        },
        {
          kop: 'Изменить настройки',
          uitleg:
            'Язык, голос, тон и исправление орфографии можно менять и ПОСРЕДИ разговора. То, что ты меняешь здесь, сразу действует для обоих.',
        },
      ],
    },
    {
      titel: 'Начать разговор',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Название разговора',
          uitleg:
            'Может остаться пустым. Оно видно только вверху твоего экрана, чтобы ты знал, с кем говоришь.',
        },
        {
          kop: 'Говорящий 1 и говорящий 2',
          uitleg:
            'Два языка этого разговора. Кто войдёт первым, займёт первое место. Языки можно поменять местами позже.',
        },
        {
          kop: 'Тон перевода',
          uitleg:
            'Слева ты выбираешь обращение на «ты» или на «вы», справа настроение: нейтральное, дружеское, деловое, официальное или партнёрское. Без указания модель почти всегда выбирает формальную форму, а в обычном разговоре это звучит отстранённо.',
        },
        {
          kop: 'Отправлять и свой голос',
          uitleg:
            'Собеседник может услышать рядом с переводом и твою собственную запись. Удобно, чтобы учить язык. Выключи это в деликатном разговоре: кто получит запись, может её сохранить.',
        },
        {
          kop: 'Исправлять ошибки в твоём тексте',
          uitleg:
            'Включено. Выключи, чтобы увидеть, что модель поняла на самом деле. Если тогда выйдет странная фраза, ты будешь знать, расслышана она неправильно или расслышана верно и потом приглажена.',
        },
        {
          kop: 'С PIN-кодом',
          uitleg:
            'Передай код на словах, а не в том же сообщении, что и ссылку. Это защищает от пересланной ссылки.',
        },
        {
          kop: 'QR-код',
          uitleg:
            'Дай собеседнику отсканировать его или отправь ссылку. Комната сама истекает через четыре часа.',
        },
      ],
    },
    {
      titel: 'Что происходит с твоим разговором',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'Текст не сохраняется',
          uitleg:
            'То, что вы говорите, не попадает в базу данных. Только когда и сколько было сказано, для учёта расходов.',
        },
        {
          kop: 'Записи исчезают сами',
          uitleg: 'Звук остаётся десять минут в памяти, а потом уходит.',
        },
        {
          kop: 'Комната истекает',
          uitleg: 'Через четыре часа после создания. После этого ссылка больше не работает.',
        },
        {
          kop: 'Есть бюджет',
          uitleg:
            'На комнату и на месяц. Если он исчерпан, приложение перестаёт переводить и говорит об этом. Это не сбой.',
        },
      ],
    },
  ],
};
